// export const theme_color_list = ['#016EFF', '#3BCFAC', '#FF6B42', '#FBC155', '#FF5186', '#E3E2E5', '#F5222D', '#778899', '#6495ED', '#FA8072', '#595961', '#9797A1', '#FEE8EA', '#FEF8EE', '#EBFAF6', '#EFEFEF', '#FF99CC', '#FF9999', '#00CCFF', '#66CC33']

export const theme_color_list = [
    '#016EFF', '#3BCFAC', '#FF6B42', '#FBC155', '#FF5186', '#778899',
    '#990000', '#996633', '#00FFCC', '#330066', '#000000', '#FF6666', '#993399',
    '#FF0000', '#FF6600', '#FFFF00', '#66CC00', '#669999', '#0033FF', '#CC00FF',
    '#FFCC00', '#FFFF99', '#336600', '#666699', '#000099', '#9900FF',

]